export default "__VITE_ASSET__BdnqNLfg__"